import {fetchData} from "../Service/graphQlService";
import {GET_RECORD_GROUPS, GET_RECORD_GROUP_MEMBERS} from "../Graphql/Queries/recordGroupsQuery";
import {GET_PROPERTY_DATA} from "../Graphql/Queries/propertiesQuery";
import {GET_CONTACT_INVESTOR_BY_ID} from "../Graphql/ContactsQueries/contactsQuery";
export const MAX_RECORD_GROUP_PROPERTY_FILTER = 25;

export function computePropertyListStats(items) {
  var emptyStats = {
    count: 0,
    total_list_price: 0,
    total_sold_price: 0,
    total_negotiation_price: 0,
    total_sqft: 0,
    total_hsc_price: 0,
    total_loan_amount: 0,
    sqft: 0,
    list_price: 0,
    negotiation_price: 0,
    net_operating_income: 0,
    vacancy: 0,
    capitalization_rate: 0,
    negotiation_cap_rate: 0,
    sold_price: 0,
    down_payment: 0,
    seller_fee_percentage: 0,
    close_cap_rate: 0,
    close_noi: 0,
    close_price_per_sqft: 0,
    price_per_sqft: 0,
    rent_per_sqft: 0,
    negotiation_price_per_sqft: 0,
    loan_amount: 0,
    ltv: 0,
    interest_rate: 0,
    lenders: 0,
  };
  if (!items || !items.length) return emptyStats;

  var sumKeys = [
    "list_price", "sold_price", "negotiation_price", "sqft", "hsc_price", "loan_amount",
    "net_operating_income", "vacancy", "capitalization_rate", "negotiation_cap_rate",
    "close_cap_rate", "close_noi", "close_price_per_sqft", "price_per_sqft", "rent_per_sqft",
    "negotiation_price_per_sqft", "down_payment", "seller_fee_percentage", "ltv", "interest_rate",
  ];
  var sums = {};
  var counts = {};
  sumKeys.forEach(function(key) {
    sums[key] = 0;
    counts[key] = 0;
  });

  items.forEach(function(item) {
    sumKeys.forEach(function(key) {
      if (item[key] === null || typeof item[key] === "undefined" || item[key] === "") return;
      var val = Number(item[key]);
      if (isNaN(val)) return;
      sums[key] += val;
      counts[key] += 1;
    });
  });

  var stats = Object.assign({}, emptyStats, {
    count: items.length,
    total_list_price: sums.list_price,
    total_sold_price: sums.sold_price,
    total_negotiation_price: sums.negotiation_price,
    total_sqft: sums.sqft,
    total_hsc_price: sums.hsc_price,
    total_loan_amount: sums.loan_amount,
  });

  sumKeys.forEach(function(key) {
    stats[key] = counts[key] ? sums[key] / counts[key] : 0;
  });

  return stats;
}

export function parseMemberIds(payload) {
  if (!payload) return [];
  var ids = payload.member_group_ids;
  if (Array.isArray(ids)) {
    return ids.map(function(id) { return Number(id); }).filter(Boolean);
  }
  if (typeof ids === "string" && ids.trim()) {
    return ids.split(",").map(function(part) { return Number(part.trim()); }).filter(Boolean);
  }
  if (payload.data && Array.isArray(payload.data)) {
    return payload.data.map(function(item) {
      return Number(item.member_id || item.contact_id || item.arcimedes_row_id || item.id);
    }).filter(Boolean);
  }
  return [];
}

export function parseGroupMemberCount(groupMembers) {
  if (groupMembers === null || typeof groupMembers === "undefined") return 0;
  if (Array.isArray(groupMembers)) return groupMembers.length;
  if (typeof groupMembers === "number") return groupMembers;
  if (typeof groupMembers === "string") {
    if (!groupMembers.trim()) return 0;
    return groupMembers.split(",").filter(Boolean).length;
  }
  return 0;
}

export function fetchRecordGroups(groupType, ownerAgentId, memberId) {
  if (!ownerAgentId) return Promise.resolve([]);
  return fetchData(GET_RECORD_GROUPS, {
    group_type: groupType,
    owner_agent_id: Number(ownerAgentId),
    member_id: memberId ? Number(memberId) : null,
  }).then(function(res) {
    var payload = res && res.data && res.data.getRecordGroups;
    if (!payload || !payload.success) return [];
    return payload.data || [];
  });
}

export function fetchRecordGroupMemberIds(groupType, ownerAgentId, groupId) {
  if (!ownerAgentId || !groupId) return Promise.resolve([]);
  return fetchData(GET_RECORD_GROUP_MEMBERS, {
    group_type: groupType,
    owner_agent_id: Number(ownerAgentId),
    group_id: Number(groupId),
  }).then(function(res) {
    var payload = res && res.data && res.data.getRecordGroupMembers;
    if (!payload || !payload.success) return [];
    return parseMemberIds(payload);
  });
}

export function fetchRecordGroupMembers(groupType, ownerAgentId, groupId) {
  if (!ownerAgentId || !groupId) return Promise.resolve({ memberIds: [], members: [] });
  return fetchData(GET_RECORD_GROUP_MEMBERS, {
    group_type: groupType,
    owner_agent_id: Number(ownerAgentId),
    group_id: Number(groupId),
  }).then(function(res) {
    var payload = res && res.data && res.data.getRecordGroupMembers;
    if (!payload || !payload.success) {
      return { memberIds: [], members: [] };
    }
    var members = payload.data || [];
    var memberIds = parseMemberIds(payload);
    if (!memberIds.length && members.length) {
      memberIds = members.map(function(item) {
        return Number(item.member_id || item.contact_id || item.arcimedes_row_id);
      }).filter(Boolean);
    }
    return { memberIds: memberIds, members: members };
  });
}

export function filterItemsByMemberIds(items, memberIds, idKey) {
  if (!memberIds || !memberIds.length) return [];
  var idSet = new Set(memberIds.map(Number));
  return (items || []).filter(function(item) {
    return idSet.has(Number(item[idKey]));
  });
}

export function paginateMemberIds(memberIds, page, pageSize) {
  var safePage = page && Number(page) > 0 ? Number(page) : 1;
  var safeSize = pageSize && Number(pageSize) > 0 ? Number(pageSize) : 25;
  var start = (safePage - 1) * safeSize;
  return memberIds.slice(start, start + safeSize);
}

export function stripRecordGroupFilters(filters) {
  var next = Object.assign({}, filters || {});
  delete next.group_id;
  delete next.record_group_id;
  delete next.owner_agent_id;
  delete next.record_group_member_ids;
  return next;
}

export function stripRecordGroupListOptions(listOptions) {
  var next = Object.assign({}, listOptions || {});
  delete next.group_id;
  delete next.record_group_id;
  delete next.owner_agent_id;
  delete next.record_group_member_ids;
  delete next.arcimedes_row_id;
  for (var i = 1; i <= MAX_RECORD_GROUP_PROPERTY_FILTER; i++) {
    delete next["arcimedes_row_id_" + i];
  }
  return next;
}

export function paginateArray(items, page, pageSize) {
  var safePage = page && Number(page) > 0 ? Number(page) : 1;
  var safeSize = pageSize && Number(pageSize) > 0 ? Number(pageSize) : 25;
  var start = (safePage - 1) * safeSize;
  return (items || []).slice(start, start + safeSize);
}

export function applyRecordGroupListOptions(listOptions) {
  return stripRecordGroupListOptions(listOptions);
}

export function fetchGroupPropertyListItems(memberIds) {
  if (!memberIds || !memberIds.length) return Promise.resolve([]);
  return Promise.all(memberIds.map(function(memberId) {
    return fetchData(GET_PROPERTY_DATA, { arcimedesRowId: String(memberId) }).then(function(res) {
      return res && res.data && res.data.getpropertyQuery ? res.data.getpropertyQuery : null;
    }).catch(function() {
      return null;
    });
  })).then(function(items) {
    return items.filter(Boolean);
  });
}

export function applyRecordGroupContactFilters(filters, groupId, ownerAgentId, memberIds) {
  return stripRecordGroupFilters(filters);
}

// getContacts has no contact_id filter, so a group can't be resolved through the
// paged list query: the members are usually outside the first page and the row
// set comes back empty. Fetch each member by contact_id instead, the same way
// property groups are resolved through fetchGroupPropertyListItems.
export function fetchGroupContactListItems(memberIds) {
  if (!memberIds || !memberIds.length) return Promise.resolve([]);
  return Promise.all(memberIds.map(function(memberId) {
    return fetchData(GET_CONTACT_INVESTOR_BY_ID, { contactid: Number(memberId) }).then(function(res) {
      var payload = res && res.data && res.data.getContactByContactid;
      return payload && payload.success && payload.contact ? payload.contact : null;
    }).catch(function() {
      return null;
    });
  })).then(function(items) {
    return items.filter(Boolean);
  });
}

// A people group is one namespace shared by the Agents and Investors modules
// (both mount PeopleGroupsTab with groupType "people"), so a group's members are
// deliberately NOT filtered by contact_type here: selecting a group shows every
// person in it. Filtering by the module's type is what made a group whose members
// were added from the other module render as "No Data Found".
export function filterVisibleGroupContacts(items) {
  return (items || []).filter(function(item) {
    return !item.deleted;
  });
}

// Column filters are normally applied by the server. Inside a group the rows come
// from per-member fetches, so the same filters are applied here. Keys that don't
// map to a field on the contact row are ignored.
export function filterGroupContactsByColumnFilters(items, filters) {
  var keys = Object.keys(filters || {});
  if (!keys.length) return items || [];
  return (items || []).filter(function(item) {
    return keys.every(function(key) {
      var expected = filters[key];
      if (expected === null || typeof expected === "undefined" || expected === "") return true;
      if (!(key in item)) return true;
      var actual = item[key];
      if (typeof expected === "boolean") return Boolean(actual) === expected;
      if (actual === null || typeof actual === "undefined") return false;
      return String(actual).toLowerCase().indexOf(String(expected).toLowerCase()) !== -1;
    });
  });
}
